/**
 * UniUni US pickup warehouses and their PRM API numeric IDs.
 *
 * IDs are defined by UniUni and documented in the PRM API appendix
 * "UniUni Hub Warehouse Location in The US".
 */

export const UNIUNI_US_WAREHOUSES = [
  { code: "LAX", id: 1, label: "Los Angeles, CA" },
  { code: "MIA", id: 2, label: "Miami, FL" },
  { code: "ORD", id: 3, label: "Chicago, IL" },
  { code: "DFW", id: 4, label: "Dallas, TX" },
  { code: "SJC", id: 12, label: "Bay Area (San Jose), CA" },
  { code: "JFK", id: 17, label: "JFK (Queens), NY" },
  { code: "EWR", id: 18, label: "Newark, NJ" },
  { code: "IAH", id: 19, label: "Houston, TX" },
  { code: "DCA", id: 26, label: "Washington, DC" },
  { code: "SEA", id: 27, label: "Seattle, WA" },
  { code: "ATL", id: 31, label: "Atlanta, GA" },
  { code: "CVG", id: 33, label: "Cincinnati, OH" },
  { code: "CLT", id: 34, label: "Charlotte, NC" },
  { code: "RDU", id: 35, label: "Raleigh-Durham, NC" },
  { code: "BOS", id: 39, label: "Boston, MA" },
  { code: "SLC", id: 41, label: "Salt Lake City, UT" },
  { code: "DEN", id: 42, label: "Denver, CO" },
  { code: "BUF", id: 45, label: "Buffalo, NY" },
] as const;

export type UniUniUsWarehouseCode =
  (typeof UNIUNI_US_WAREHOUSES)[number]["code"];

const WAREHOUSE_IDS = new Set<number>(UNIUNI_US_WAREHOUSES.map((w) => w.id));

export function isValidUniUniUsWarehouseId(id: unknown): id is number {
  return typeof id === "number" && WAREHOUSE_IDS.has(id);
}

export function getUniUniWarehouseLabel(id: number): string | undefined {
  return UNIUNI_US_WAREHOUSES.find((w) => w.id === id)?.label;
}

export function getUniUniWarehouseCode(id: number): string | undefined {
  return UNIUNI_US_WAREHOUSES.find((w) => w.id === id)?.code;
}
